import React, {PureComponent} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Container, Sidebar, Item, Menu, Image, Icon} from "semantic-ui-react";
import classnames from "classnames";
import {push} from "react-router-redux";
import logo from "../assets/images/logo.svg";

class Header extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    pages: PropTypes.array.isRequired,
    pathname: PropTypes.string.isRequired,
    navigateTo: PropTypes.func.isRequired,
    season: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  navToPage = path => {
    this.setState({ visible: false });
    this.props.navigateTo(path);
  };

  closeMenu = () => {
    if (this.state.visible) this.setState({visible: false})
  };

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  render() {
    const { show, pages, season, pathname } = this.props;
    const { visible } = this.state;
	let header;

    if (pages) {
      pages.sort(function(a,b) {return (a.orderNumberC > b.orderNumberC) ? 1 : ((b.orderNumberC > a.orderNumberC) ? -1 : 0);} );
    }

	if (process.env.REACT_APP_SHOW_HEADER_FOOTER == 1)
          {  
		  	header = <Container id="cbsGlobalHeader">
                    <Menu className="large top borderless">
                        <Container className="globalPadding noPaddingMobile">
                            <Item className="noPaddingComputer">
                                <Image src={logo} width="109" alt="" />
                            </Item>
                            <div className="right menu">
                                <div className="item">
                                    <a
                                        href=""
                                        className="small ui primary button"
                                    >
                                        Back
                                    </a>
                                </div>
                            </div>
                        </Container>
                    </Menu>
                </Container>;
		  }
	
    return (
      <div onClick={() => this.closeMenu()}>
        <Sidebar
          as={Menu}
          animation="overlay"
          visible={visible}
          vertical
          inverted
        >
          <Item className="showTitle">
            <h3>{show.name}</h3>
          </Item>
          {pages.map(page => (
            <Item
              key={page.pageNameC}
              className={classnames({
                active: pathname === page.path,
              })}
              onClick={() => this.navToPage(page.path)}
            >
              {page.pageNameC}
            </Item>
          ))}
        </Sidebar>
		
		{header}
            
        <Container id="mainNav" className="ui globalPadding">
          <Container className="ui">
            <Menu className="ui large secondary inverted pointing menu">
              <div className="showTitle">
                <h2>{show.name}</h2>
              </div>
              <div className="right menu">
                {pages.map(page => (
                  <Item
                    key={page.pageNameC}
                    className={classnames({
                      active: pathname === page.path,
                    })}
                    onClick={() => this.navToPage(page.path)}
                  >
                    {page.pageNameC}
                  </Item>
                ))}
        {process.env.REACT_APP_SHOW_TERMS == 1 && 
                    <Item onClick={() => this.navToPage('/terms')}>Terms</Item> 
                }
              </div>
              <Item className="toc item">
                <Icon name="sidebar" onClick={this.toggleVisibility} />
              </Item>
            </Menu>
          </Container>
        </Container>

        <Container className="ui heroBanner">
          <Image src={season.heroImageUrlC} alt={show.name} />
        </Container>
      </div>
    );
        }
}

const state = (state = {}) => ({ pathname: state.router.location.pathname });

const mapDispatchToProps = dispatch => ({
  navigateTo: location => {
    dispatch(push(location));
  },
});

export default connect(state, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js